export default {
  colors: { primary: '#00594f', primaryHover: '#34b78f' },
  borders: { radius: '0px' },
};
